import { useCallback, useState } from "react";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Popup from "../../../components/Popup";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import Reserve from "../../../assets/img/SolutionsIcons/AgilysysReserve.svg";
import { Header } from "../../../components/Header";

const ReserveFPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const [showVideo, setShowVideo] = useState<boolean>(false);
    return (
      <div className="page splash reserveFPage">
        <div className="page-title">
          <img src={Reserve} alt="" />
        </div>
        <Header />
        <div className="text-blocks">
          <div className="std-text">
            A complete online table reservation, wait-list and venue 
            management system that is designed to display and manage 
            seat availability for a wide range of venues including 
            executive dining rooms, corporate cafeterias and more.{"\n\n"}
          </div>
        </div>
        <div
          className="play-video"
          onClick={() => {
            _logEvent("click", "Solutions - Reserve", "Play Video");
            addFlow("Play Video");
            setShowVideo(true);
          }}
        >
          <PlayTriangle />
          Play Video
        </div>
        <img
          className="img-1"
          src={
            "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/Reserve1.png"
          }
          alt=""
        />
        <Popup
          showPopup={showVideo}
          setShowPopup={() => setShowVideo(false)}
          disableOffClick={true}
        >
          <>
            {showVideo && (
              <video
                autoPlay
                controls
                src={
                  "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/Reserve2.mp4"
                }
              />
            )}
          </>
        </Popup>
      </div>
    );
}

export default ReserveFPage;